// extracted by mini-css-extract-plugin
module.exports = {"save":"PrinterSaveButton_save__1MhmY","test-text":"PrinterSaveButton_test-text__1zl66","test-text-ltr":"PrinterSaveButton_test-text-ltr__E_Cg3"};